import React, { Fragment } from "react";
import PropTypes from "prop-types";
import ReactHighcharts from "react-highcharts";
import bubbleChart from "models/BubbleChart";
import { withStyles } from "material-ui/styles";

const styles = () => ({
  verticalWriting: {
    "-webkit-writing-mode": "vertical-rl",
    "-ms-writing-mode": "tb-rl",
    "writing-mode": "vertical-rl"
  }
});

class BubbleChart extends React.Component {
  shouldComponentUpdate(nextProps) {
    return (
      nextProps.xdata !== this.props.xdata ||
      nextProps.ydata !== this.props.ydata
    );
  }
  render() {
    return (
      <Fragment>
        <ReactHighcharts config={bubbleChart(this.props)}/>
      </Fragment>
    );
  }
}

BubbleChart.propTypes = {
  xdata: PropTypes.arrayOf(PropTypes.number).isRequired,
  ydata: PropTypes.arrayOf(PropTypes.number).isRequired
};

export default withStyles(styles)(BubbleChart);



// WEBPACK FOOTER //
// ./src/components/ReportDetail/BubbleChart.jsx